module.exports = __webpack_public_path__ + "img/icon_service_off.e4602b8d.svg";